export const APP_ENV = process.env.REACT_APP_APP_ENV;
export const TTP_API_URL = process.env.REACT_APP_TTP_API_URL;
export const TTP_MEDIA_URL = process.env.REACT_APP_TTP_MEDIA_URL;
export const TTP_PORTAL_URL = process.env.REACT_APP_TTP_PORTAL_URL;
export const TTP_BLOG_URL = process.env.REACT_APP_TTP_BLOG_URL;
export const TTP_FORUM_URL = process.env.REACT_APP_TTP_FORUM_URL;
export const TTP_FLUX_URL = process.env.REACT_APP_TTP_FLUX_URL;
export const TTP_WEBTOOL_URL = process.env.REACT_APP_TTP_WEBTOOL_URL;
export const TTP_EVENT_URL = process.env.REACT_APP_TTP_EVENT_URL;
export const TTP_EMAILING_URL = process.env.REACT_APP_TTP_EMAILING_URL;
export const TTP_HOME_URL = process.env.REACT_APP_TTP_HOME_URL;
export const TTP_FFF_BLOG = process.env.REACT_APP_TTP_FFF_BLOG;
export const TTP_DEG_BLOG = process.env.REACT_APP_TTP_DEG_BLOG;
export const TTP_HUB_URL = process.env.REACT_APP_TTP_HUB_URL;
export const TTP_BE_ACCOUNTANTS_BLOG =
  process.env.REACT_APP_TTP_BE_ACCOUNTANTS_BLOG;
export const TTP_TALK_URL = process.env.REACT_APP_TTP_TALK_URL;
export const TTP_BILLTOBOX_URL = process.env.REACT_APP_TTP_BILLTOBOX_URL;
export const TTP_EBOX_URL = process.env.REACT_APP_TTP_EBOX_URL;
export const TTP_DASHBOARD_URL = process.env.REACT_APP_TTP_DASHBOARD_URL;
export const TTP_ACCOUNTING_URL = process.env.REACT_APP_TTP_ACCOUNTING_URL;
export const TTP_POWERTEAM_URL = process.env.REACT_APP_TTP_POWERTEAM_URL;

export const TTP_LOGO_URL = "/img/logo.png";
export const TTP_LOGO2_URL = "/img/logo2.svg";

export const AUTH_COOKIE_NAME = `ttp_auth_${APP_ENV}`;

export const COMMUNITY_NAME_MAX_LENGTH = 20;
export const COMMUNITY_DEFAULT_LOGO_URL = "/img/community-default-logo.png";

export const MENUS = {
  GUEST: [],
  READER: ["COMMUNITIES", "TYPES", "ALBUMS"],
  MEMBER: ["COMMUNITIES", "TYPES", "ALBUMS"],
  ADMIN: ["COMMUNITIES", "TYPES", "ALBUMS"]
};

export const PAGES = {
  HOME_PAGE: "HOME_PAGE",
  AUTHOR_PAGE: "AUTHOR_PAGE",
  CATEGORY_PAGE: "CATEGORY_PAGE",
  COMMUNITIES_PAGE: "COMMUNITIES_PAGE",
  ARTICLE_PAGE: "ARTICLE_PAGE",
  SETTING_PAGE: "SETTING_PAGE"
};

export const SOCIAL_NETWORKS_HOSTS = {
  FACEBOOK: "https://www.facebook.com",
  TWITTER: "https://www.twitter.com",
  LINKEDIN: "https://www.linkedin.com"
};

export const BUBBLE_EVENTS = {
  DELETE_SELECTED_MEDIAS: "DELETE_SELECTED_MEDIAS",
  ADD_TO_ALBUM: "ADD_TO_ALBUM"
};

export const SETTINGS_USERS_PAGE_LIMIT = 9;

// export const CLIENT_CREDENTIAL = {
//   grant_type: "client_credentials",
//   client_id: "10011",
//   client_secret: "BlogSecretS#K$",
//   scope: "ttp"
// };

export const CLIENT_CREDENTIAL = {
  grant_type: "client_credentials",
  client_id: "11111",
  client_secret: "PublicSecret",
  scope: "public"
};

export const WHERETOBILL_CREDENTIAL = {
  grant_type: "client_credentials",
  client_id: "20020",
  client_secret: "gs7r0s5ab01vAr7Rdo8w5bsr6h7uhq0j0q1yctfz",
  scope: "wtb_partner"
};
export const BILLTOBOX_CREDENTIAL = {
  scope: "billtobox"
};

export const FILTER_PROPERTIES = {
  BLOG: [
    { label: "category", property: "category.id", isDefault: true },
    { label: "tag", property: "tag.id", isDefault: true },
    { label: "theme", property: "theme.id", isDefault: false },
    { label: "type", property: "type.id", isDefault: false }
  ],
  EVENT: [
    { label: "category", property: "category.id", isDefault: true },
    { label: "type", property: "type.id", isDefault: false }
  ],
  MEDIA: [
    { label: "category", property: "category.id", isDefault: false },
    { label: "tag", property: "tag.id", isDefault: false },
    { label: "type", property: "docType", isDefault: true }
  ],
  EMAILING: [
    { label: "category", property: "category.id", isDefault: true },
    { label: "type", property: "type.id", isDefault: false }
  ]
};

export const NB_DISPOSITIONS = {
  BLOG: 3,
  EVENT: 1,
  MEDIA: 1,
  EMAILING: 1
};

export const LAYOUT_DISPOSITIONS = {
  BLOG: { B1: 5, B2: 3, B3: 5 },
  EVENT: { B1: 4 },
  MEDIA: { B1: 8 },
  EMAILING: { B1: 4 }
};



// WEBPACK FOOTER //
// ./src/config/index.js